struct Params_std140_0
{
    @align(16) worldSize_0 : vec2<f32>,
    @align(8) viewSize_0 : vec2<f32>,
    @align(16) gridSize_0 : vec2<f32>,
    @align(8) dotSize_0 : vec2<f32>,
    @align(16) fieldUvScale_0 : vec2<f32>,
    @align(8) pointer_0 : vec2<f32>,
    @align(16) pointerRadius_0 : f32,
    @align(4) pointerForce_0 : f32,
    @align(8) particleCount_0 : f32,
    @align(4) binCount_0 : f32,
    @align(16) binSize_0 : f32,
    @align(4) returnForce_0 : f32,
    @align(8) returnDamping_0 : f32,
    @align(4) dt_0 : f32,
    @align(16) mu_k_0 : f32,
    @align(4) sigma_k_0 : f32,
    @align(8) w_k_0 : f32,
    @align(4) mu_g_0 : f32,
    @align(16) sigma_g_0 : f32,
    @align(4) c_rep_0 : f32,
    @align(8) r_rep_0 : f32,
    @align(4) resetAttempts_0 : f32,
    @align(16) initialFieldScattering_0 : f32,
};

@binding(0) @group(0) var<uniform> data_params_0 : Params_std140_0;
struct Particle_std430_0
{
    @align(8) position_0 : vec2<f32>,
    @align(8) velocity_0 : vec2<f32>,
    @align(8) home_0 : vec2<f32>,
    @align(8) frame_0 : u32,
    @align(4) _pad_0 : u32,
};

@binding(1) @group(0) var<storage, read> data_source_0 : array<Particle_std430_0>;

@binding(2) @group(0) var<storage, read_write> data_destination_0 : array<Particle_std430_0>;

@binding(3) @group(0) var<storage, read> data_binOffsets_0 : array<u32>;

@binding(4) @group(0) var<storage, read_write> data_binCounters_0 : array<atomic<u32>>;

@compute
@workgroup_size(64, 1, 1)
fn clear(@builtin(global_invocation_id) gid_0 : vec3<u32>)
{
    var _S1 : u32 = gid_0.x;
    if(f32(_S1) >= (data_params_0.binCount_0 + 1.0f))
    {
        return;
    }
    atomicStore(&(data_binCounters_0[_S1]), u32(0));
    return;
}

@compute
@workgroup_size(64, 1, 1)
fn sort(@builtin(global_invocation_id) gid_1 : vec3<u32>)
{
    var _S2 : u32 = gid_1.x;
    if(f32(_S2) >= (data_params_0.particleCount_0))
    {
        return;
    }
    var particle_0 : Particle_std430_0 = data_source_0[_S2];
    var binF_0 : vec2<f32> = floor((particle_0.position_0 + vec2<f32>(0.5f) * data_params_0.worldSize_0) / vec2<f32>(data_params_0.binSize_0));
    var binIndex_0 : u32 = u32(clamp(binF_0.y, 0.0f, data_params_0.gridSize_0.y - 1.0f)) * u32(data_params_0.gridSize_0.x) + u32(clamp(binF_0.x, 0.0f, data_params_0.gridSize_0.x - 1.0f));
    var _S3 : u32 = data_binOffsets_0[binIndex_0];
    var _S4 : u32 = atomicAdd(&(data_binCounters_0[binIndex_0]), u32(1));
    data_destination_0[_S3 + _S4] = particle_0;
    return;
}

